import PropTypes from 'prop-types';
import { isEmpty, map, sortBy, uniqueId } from 'lodash';
import { FormattedMessage } from 'react-intl';
import AllOrOne from '../../AllOrOne/AllOrOne';
import Location from '../Location/Location';
import addresses from '../../../utils/Addresses/';
import cn from '../../../../utils/cn';

const Locations = ({
  className = '',
  clickableAddress = false,
  hideLocationName = false,
  isInNetworkGroup = true,
  locations = [],
  originLatLng = [],
  showCount = true,
  showMore = false,
  locationAdditionalContentComponent = null,
  intlProvider = {},
  showHoursIcon = false,
}) => {
  const calculatedDistances = map(locations, location => addresses.calculateDistance(location, originLatLng));
  const formattedLocations = sortBy(calculatedDistances, 'distanceVal') || [];
  let locationText;
  if (formattedLocations.length === 1) {
    locationText = (!isEmpty(intlProvider)) ? (
      <FormattedMessage id="UdrOGf" description="location-singular" defaultMessage="Location">
        {txt => (<h4 className="text-sm text-text-blue font-medium font-heavy-font">{`${formattedLocations.length} ${txt}`}</h4>)}
      </FormattedMessage>
    ) : <h4 className="text-sm text-text-blue font-medium font-heavy-font">{`${formattedLocations.length} Location`}</h4>;
  } else {
    locationText = (!isEmpty(intlProvider)) ? (
      <FormattedMessage id="NRZ/fl" description="location-plural" defaultMessage="Locations">
        {txt => <h4 className="text-sm text-text-blue font-medium font-heavy-font">{`${formattedLocations.length} ${txt}`}</h4>}
      </FormattedMessage>
    ) : <h4 className="text-sm text-text-blue font-medium font-heavy-font">{`${formattedLocations.length} Locations`}</h4>;
  }

  if (isEmpty(formattedLocations)) {
    return null;
  }

  const locationClass = () => cn({
    'border-b border-solid border-light-border-blue': true,
    'mb-2 pt-2 pb-2 last:border-0': true,
  });

  return (
    <div className={`${className}`}>
      {showCount &&
        locationText}
      <AllOrOne showAll={showMore}>
        {
          formattedLocations.map(location => (
            <div
              className={locationClass()}
              key={location.id || uniqueId(location.name || location.displayName)}
            >
              <Location
                clickableAddress={clickableAddress}
                hideLocationName={hideLocationName}
                isInNetworkGroup={isInNetworkGroup}
                location={location}
                originLatLng={originLatLng}
                showMore={showMore}
                additionalContentComponent={locationAdditionalContentComponent}
                intlProvider={intlProvider}
                showHoursIcon={showHoursIcon}
              />
            </div>
          ))
        }
      </AllOrOne>
    </div>
  );
};

Locations.propTypes = {
  className: PropTypes.string,
  clickableAddress: PropTypes.bool,
  hideLocationName: PropTypes.bool,
  isInNetworkGroup: PropTypes.bool,
  locations: PropTypes.array,
  originLatLng: PropTypes.array,
  showCount: PropTypes.bool,
  showHoursIcon: PropTypes.bool,
  showMore: PropTypes.bool,
  /**
   * Property passed down to location component that will render in the main content area of the component.
   * This feature is used to render an edit location link.
   */
  locationAdditionalContentComponent: PropTypes.func,
  intlProvider: PropTypes.object,
};

export default Locations;
